import i18next from 'i18next';
import * as yup from 'yup';

export const remarkingSchema = yup.object().shape({
    markingCode: yup
        .string()
        .trim()
        .required(i18next.t('components.form.required')),
    remarkingReason: yup
        .string()
        .nullable()
        .required(i18next.t('components.form.required')),
    comment: yup.string().notRequired(),
});
